import { useState } from 'react';
import type { TopShareholdersProps } from '@/pages/CompanyReport/components/Ownership';
import { TopShareholdersAccordionDetails } from '@/pages/CompanyReport/components/Ownership';

const TopShareholdersAccordion = ({
  topShareholders,
}: Pick<TopShareholdersProps, 'topShareholders'>) => {
  const [openDetails, setOpenDetails] = useState<number[]>([]);

  const handleClick = (shareholderId: number) => {
    if (openDetails.includes(shareholderId)) {
      setOpenDetails(openDetails.filter((id) => id !== shareholderId));
    } else {
      setOpenDetails([...openDetails, shareholderId]);
    }
  };

  return (
    <>
      {topShareholders.map((shareholder) => (
        <TopShareholdersAccordionDetails
          key={`TopShareholders-${shareholder.rankSharesHeld}`}
          rankSharesHeld={shareholder.rankSharesHeld}
          owner={shareholder.owner}
          holdingValue={shareholder.holdingValue}
          holdingDate={shareholder.holdingDate}
          sharesHeldFormat={shareholder.sharesHeldFormat}
          percentOfPortfolio={shareholder.percentOfPortfolio}
          percentOfSharesOutstanding={shareholder.percentOfSharesOutstanding}
          percentSharesChanged={shareholder.percentSharesChanged}
          handleClick={handleClick}
          isOpen={openDetails.includes(shareholder.rankSharesHeld)}
        />
      ))}
    </>
  );
};
export default TopShareholdersAccordion;
